/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	__webpack_require__.p = typeof window !== 'undefined' && window.__STATICS_BASE_URL__ || __webpack_require__.p;
/******/
/******/ 	(function(){
/******/ 	    if (typeof document !== 'undefined') {
/******/ 	        var style = document.getElementById("wixCodeApi.stylable.bundle.css");
/******/ 	        if(!style){
/******/ 	            style = document.createElement('style');
/******/ 	            style.id = "wixCodeApi.stylable.bundle.css";
/******/ 	            document.head.appendChild(style);
/******/ 	        }
/******/ 	        style.textContent = "";
/******/ 	    }
/******/ 	    return ;
/******/ 	}())
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1369);
/******/ })
/************************************************************************/
/******/ ({

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(23);
var toLength = __webpack_require__(45);
var toAbsoluteIndex = __webpack_require__(108);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(41);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(7);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(110) });


/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(12);
var IE8_DOM_DEFINE = __webpack_require__(70);
var toPrimitive = __webpack_require__(56);
var dP = Object.defineProperty;

exports.f = __webpack_require__(13) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(29);
var gOPS = __webpack_require__(57);
var pIE = __webpack_require__(40);
var toObject = __webpack_require__(27);
var IObject = __webpack_require__(52);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(18)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(71);
var hiddenKeys = __webpack_require__(49).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(40);
var createDesc = __webpack_require__(33);
var toIObject = __webpack_require__(23);
var toPrimitive = __webpack_require__(56);
var has = __webpack_require__(17);
var IE8_DOM_DEFINE = __webpack_require__(70);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(13) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(25);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(41);
var defined = __webpack_require__(42);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(53);
var descriptor = __webpack_require__(33);
var setToStringTag = __webpack_require__(37);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(16)(IteratorPrototype, __webpack_require__(6)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(11);
var anObject = __webpack_require__(12);
var getKeys = __webpack_require__(29);

module.exports = __webpack_require__(13) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(18)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(131);
var step = __webpack_require__(94);
var Iterators = __webpack_require__(22);
var toIObject = __webpack_require__(23);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(61)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ 131:
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pmRpc = __webpack_require__(1370);

var rpc = _interopRequireWildcard(_pmRpc);

var _wixCode = __webpack_require__(406);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// // const wixFullstoryLoader = require('wix-fullstory-loader');
// // wixFullstoryLoader({label: 'progallery-wix-code-api'});

var GalleryWixCodeApi = function () {
  function GalleryWixCodeApi() {
    _classCallCheck(this, GalleryWixCodeApi);

    this.resetGalleryInEditor = this.resetGalleryInEditor.bind(this);

    this.compId = 'pro-gallery-no-comp-id';

    this.waitForWixSdk();
    this.resetGallery();
  }

  _createClass(GalleryWixCodeApi, [{
    key: 'waitForWixSdk',
    value: function waitForWixSdk() {
      var _this = this;

      this.wixSdkReadyInterval = setInterval(function () {
        if (window.Wix && window.Wix.Utils) {
          clearInterval(_this.wixSdkReadyInterval);
          // console.log('proGallery Wix SDK is Ready!');
          _this.onWixSdkReady();
        }
      }, 100);
    }
  }, {
    key: 'setClickCallback',
    value: function setClickCallback(callback) {
      if (typeof callback == 'function') {
        this.itemClickedCallbacks.push(callback);
      }
    }
  }, {
    key: 'onItemClicked',
    value: function onItemClicked(itemProps) {
      var _item = {
        compId: this.compId,
        event: {
          action: 'itemClicked',
          id: itemProps.id,
          imageIndex: itemProps.idx,
          item: {
            uri: itemProps.originalsUrl,
            description: itemProps && itemProps.description,
            alt: itemProps && itemProps.title,
            title: itemProps && itemProps.title,
            height: itemProps && itemProps.style && itemProps.style.height,
            width: itemProps && itemProps.style && itemProps.style.width,
            link: itemProps && itemProps.linkUrl,
            target: itemProps && itemProps.linkOpenType
          }
        }
      };

      //notify pubsub listeners
      try {
        this.wixSdkReady && window.Wix.PubSub.publish('galleryAction_' + this.compId, {
          action: 'onItemClicked',
          payload: _item
        }, true);
      } catch (e) {
        console.warn('Gallery failed to publish onItemClicked action', e);
      }

      //activate open callbacks
      try {
        for (var i = 0; i < this.itemClickedCallbacks.length; i++) {
          var callback = this.itemClickedCallbacks[i];
          if (typeof callback == 'function') {
            callback(_item);
          }
        }
      } catch (e) {
        console.warn('Gallery failed to activate onItemClicked callbacks', e);
      }
    }
  }, {
    key: 'setItemChangedCallback',
    value: function setItemChangedCallback(callback) {
      if (typeof callback == 'function') {
        this.itemChangedCallbacks.push(callback);
      }
    }
  }, {
    key: 'onItemChanged',
    value: function onItemChanged(item) {
      try {
        var _item = {
          compId: this.compId,
          event: {
            action: 'imageChanged',
            id: item.id,
            imageIndex: item.idx,
            item: (0, _wixCode.proGalleryItemToWixCode)(item)
          }
        };
        this.wixSdkReady && window.Wix.PubSub.publish('galleryAction_' + this.compId, {
          action: 'onCurrentItemChanged',
          payload: _item
        }, true);
        for (var i = 0; i < this.itemChangedCallbacks.length; i++) {
          var callback = this.itemChangedCallbacks[i];
          if (typeof callback == 'function') {
            callback(_item);
          }
        }
      } catch (e) {
        //  
      }
    }
  }, {
    key: 'resetGalleryInEditor',
    value: function resetGalleryInEditor() {
      if (this.wixSdkReady && window.Wix && window.Wix.Utils && window.Wix.Utils.getViewMode() == 'editor') {
        this.resetGallery();
      }
    }
  }, {
    key: 'resetGallery',
    value: function resetGallery() {
      if (this.originalGalleryItems && window.proGalleryServices) {
        window.proGalleryServices.setImages(this.originalGalleryItems);
      }

      this.itemClickedCallbacks = [];
      this.itemChangedCallbacks = [];
    }
  }, {
    key: 'setItems',
    value: function setItems(items) {
      if (window.proGalleryServices) {
        if (!this.originalGalleryItems) {
          this.originalGalleryItems = window.proGalleryServices.getItemsDto();
        }
        window.proGalleryServices.setImages((0, _wixCode.wixCodeItemsToProGallery)(items));
        // console.log('proGallery setItems for WixCode (replaced rendered gallery items)');
      } else {
        if (!this.originalGalleryItems && window['prerenderedGallery'] && window['prerenderedGallery']['items']) {
          this.originalGalleryItems = window['prerenderedGallery']['items'];
        }
        //store the items until the proGalleryServices will be ready
        window['itemsFromWixCode'] = (0, _wixCode.wixCodeItemsToProGallery)(items);
        // console.log('proGallery setItems for WixCode (stored items for later render)');
      }
    }
  }, {
    key: 'getItems',
    value: function getItems() {
      if (window.proGalleryServices) {
        return (0, _wixCode.proGalleryItemsToWixCode)(window.proGalleryServices.getItemsDto());
      } else {
        return [];
      }
    }
  }, {
    key: 'setStyleParams',
    value: function setStyleParams(styleParams) {

      var mapStyleParams = function mapStyleParams(styleParams) {
        var mappedStyleParams = {};
        var keys = Object.keys(styleParams);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            mappedStyleParams[key] = mapStyleParam(key, styleParams[key]);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return mappedStyleParams;
      };

      var mapStyleParam = function mapStyleParam(key, val) {
        var newVal = val;
        switch (key) {
          case 'itemClick':
            {
              switch (val) {
                case 'none':
                case 'disabled':
                  newVal = 'nothing';
                  break;
                case 'expand':
                case 'zoomMode':
                  newVal = 'expand';
                  break;
                case 'link':
                case 'goToLink':
                  newVal = 'link';
                  break;
              }
            }
        }
        return newVal;
      };

      try {
        var mappedStyleParams = mapStyleParams(styleParams);
        if (window.proGalleryServices) {
          window.proGalleryServices.overrideStyleParams(mappedStyleParams);
        } else {
          window.styles = mappedStyleParams;
        }
        return mappedStyleParams;
      } catch (e) {
        console.error('Failed to set styleParams', e);
        return false;
      }
    }
  }, {
    key: 'onWixSdkReady',
    value: function onWixSdkReady() {
      var _this2 = this;

      //listen to editor/preview changes
      try {
        window.Wix.addEventListener(window.Wix.Events.EDIT_MODE_CHANGE, this.resetGalleryInEditor);
        this.compId = window.Wix.Utils.getCompId();
        this.wixSdkReady = true;
      } catch (e) {
        this.wixSdkReady = false;
        // console.warn('Cannot use wix sdk for wixCode', e);
      }

      try {
        this.wixSdkReady && window.Wix.PubSub.subscribe('galleryAction_' + this.compId, function (_ref) {
          var data = _ref.data;

          var api = _this2.generatePubsubApi();
          if (typeof api[data.action] === 'function') {
            api[data.action](data.payload);
          }
        }, true);
      } catch (e) {
        console.warn('Cannot subscribe to wix pubsub for wixCode', e);
      }
    }
  }, {
    key: 'generateApi',
    value: function generateApi() {
      var _this3 = this;

      return {
        getItems: function getItems() {
          return _this3.getItems();
        },
        setItems: function setItems(items) {
          return _this3.setItems(items);
        },
        onItemClicked: function onItemClicked(callback) {
          return _this3.setClickCallback(callback);
        },
        onCurrentItemChanged: function onCurrentItemChanged(callback) {
          return _this3.setItemChangedCallback(callback);
        },
        setClickAction: function setClickAction(action) {
          return _this3.setStyleParams({ itemClick: action });
        } //action is: 'none' / 'expand' / 'link'
      };
    }
  }, {
    key: 'generatePubsubApi',
    value: function generatePubsubApi() {
      var _this4 = this;

      return {
        getItems: function getItems() {
          return _this4.getItems();
        },
        setItems: function setItems(_ref2) {
          var items = _ref2.items;
          return _this4.setItems(items);
        },
        onItemClicked: function onItemClicked(_ref3) {
          var callback = _ref3.callback;
          return _this4.setClickCallback(callback);
        },
        onCurrentItemChanged: function onCurrentItemChanged(_ref4) {
          var callback = _ref4.callback;
          return _this4.setItemChangedCallback(callback);
        },
        setClickAction: function setClickAction(_ref5) {
          var action = _ref5.action;
          return _this4.setStyleParams({ itemClick: action });
        } //action is: 'none' / 'expand' / 'link'
      };
    }
  }]);

  return GalleryWixCodeApi;
}();

var galleryWixCodeApi = window['galleryWixCodeApi'] = new GalleryWixCodeApi();

try {
  rpc.api.set('publicApi', galleryWixCodeApi.generateApi());
  // console.log('proGallery WixCode exportAPI complete');
} catch (e) {}
// console.warn('Error in WixCode exportAPI ', e);


// try {
//   Wix.Performance.applicationLoaded(); //report application ready to wixCode
// } catch (e) {
//   console.warn('Error reporting applicationLoaded to wixCode', e);
// }

/***/ }),

/***/ 1370:
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.pmrpc=e():t.pmrpc=e()}(self,function(){return function(t){var e={};function r(n){if(e[n])return e[n].exports;var o=e[n]={i:n,l:!1,exports:{}};return t[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:n})},r.r=function(t){Object.defineProperty(t,"__esModule",{value:!0})},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=73)}([function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={INVOKE:"invoke",RPC_RESOLVE:"rpc-resolve",RPC_REJECT:"rpc-reject",API_DESCRIPTION:"api-desc",INVOKE_FUNCTION:"invoke-func",RESOLVE:"resolve",REJECT:"reject",REQUEST_API:"request-api"}},function(t,e,r){var n=r(41);t.exports=function(t,e){var r=t.__data__;return n(e)?r["string"==typeof e?"string":"hash"]:r.map}},function(t,e,r){var n=r(19);t.exports=function(t,e){for(var r=t.length;r--;)if(n(t[r][0],e))return r;return-1}},function(t,e,r){var n=r(10)(Object,"create");t.exports=n},function(t,e,r){var n=r(13),o=r(67),i=r(66),u="[object Null]",a="[object Undefined]",c=n?n.toStringTag:void 0;t.exports=function(t){return null==t?void 0===t?a:u:c&&c in Object(t)?o(t):i(t)}},function(t,e,r){var n=r(71);t.exports=function(t,e,r){var o=null==t?void 0:n(t,e);return void 0===o?r:o}},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.deserialize=e.serialize=void 0;var n=i(r(5)),o=i(r(25));function i(t){return t&&t.__esModule?t:{default:t}}e.serialize=function(t){return Promise.reject((0,o.default)(t)?{type:(e=t).constructor.name,message:e.message,stack:e.stack}:t);var e},e.deserialize=function(t){return function(){var t=(arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).type;return"Error"===t||(0,o.default)((0,n.default)(self,[t,"prototype"]))}(t)?function(t){var e=t.type,r=t.stack,n=t.message,o=new(self[e]||Error)(n);return o.stack=r,o}(t):t}},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.sendResponse=e.send=void 0;var n=r(17);function o(t){if(Array.isArray(t)){for(var e=0,r=Array(t.length);e<t.length;e++)r[e]=t[e];return r}return Array.from(t)}e.send=function(t,e){var r=e.target,i=e.targetOrigin,u=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[];return new Promise(function(e){var a=new MessageChannel,c=a.port1,s=a.port2;t.__port=s,(0,n.isWorker)()||r instanceof Worker||r instanceof MessagePort?r.postMessage(t,[s].concat(o(u))):r.postMessage(t,i,[s].concat(o(u))),c.onmessage=function(t){var r=t.data;return e(r)}})},e.sendResponse=function(t,e){return function(r){return t.postMessage({intent:e,result:r})}}},function(t,e){t.exports=function(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}},function(t,e,r){var n=r(4),o=r(8),i="[object AsyncFunction]",u="[object Function]",a="[object GeneratorFunction]",c="[object Proxy]";t.exports=function(t){if(!o(t))return!1;var e=n(t);return e==u||e==a||e==i||e==c}},function(t,e,r){var n=r(58),o=r(54);t.exports=function(t,e){var r=o(t,e);return n(r)?r:void 0}},function(t,e){t.exports=function(t){return null!=t&&"object"==typeof t}},function(t,e,r){var n=r(69),o="object"==typeof self&&self&&self.Object===Object&&self,i=n||o||Function("return this")();t.exports=i},function(t,e,r){var n=r(12).Symbol;t.exports=n},function(t,e,r){var n=r(4),o=r(11),i="[object Symbol]";t.exports=function(t){return"symbol"==typeof t||o(t)&&n(t)==i}},function(t,e){var r=Array.isArray;t.exports=r},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n,o=r(0),i=(n=o)&&n.__esModule?n:{default:n},u=r(6);e.default=function(t){var e=t.intent,r=t.result;switch(e){case i.default.RESOLVE:return r;case i.default.REJECT:return Promise.reject((0,u.deserialize)(r));default:return Promise.reject()}}},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});e.isWorker=function(){return"undefined"!=typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope},e.getChildFrameById=function(t){return document.getElementById(t)}},function(t,e,r){var n=r(14),o=1/0;t.exports=function(t){if("string"==typeof t||n(t))return t;var e=t+"";return"0"==e&&1/t==-o?"-0":e}},function(t,e){t.exports=function(t,e){return t===e||t!=t&&e!=e}},function(t,e,r){var n=r(15),o=r(70),i=r(65),u=r(37);t.exports=function(t,e){return n(t)?t:o(t,e)?[t]:i(u(t))}},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=!1;e.addSingleHandler=function(t){n||(n=!0,self.addEventListener("message",t))},e.removeSingleHandler=function(t){self.removeEventListener("message",t),n=!1}},function(t,e){t.exports=function(t,e){return function(r){return t(e(r))}}},function(t,e,r){var n=r(22)(Object.getPrototypeOf,Object);t.exports=n},function(t,e,r){var n=r(4),o=r(23),i=r(11),u="[object Object]",a=Function.prototype,c=Object.prototype,s=a.toString,f=c.hasOwnProperty,p=s.call(Object);t.exports=function(t){if(!i(t)||n(t)!=u)return!1;var e=o(t);if(null===e)return!0;var r=f.call(e,"constructor")&&e.constructor;return"function"==typeof r&&r instanceof r&&s.call(r)==p}},function(t,e,r){var n=r(4),o=r(11),i=r(24),u="[object DOMException]",a="[object Error]";t.exports=function(t){if(!o(t))return!1;var e=n(t);return e==a||e==u||"string"==typeof t.message&&"string"==typeof t.name&&!i(t)}},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.deserialize=e.serialize=void 0;var n=a(r(9)),o=r(7),i=a(r(0)),u=a(r(16));function a(t){return t&&t.__esModule?t:{default:t}}e.serialize=function(t){return t.reduce(function(t,e){var r=t.args,u=t.transfer;if((0,n.default)(e)){var a=new MessageChannel,c=a.port1,s=a.port2;c.onmessage=function(t){var r=t.data,n=r.__port;Promise.resolve(e.apply(void 0,function(t){if(Array.isArray(t)){for(var e=0,r=Array(t.length);e<t.length;e++)r[e]=t[e];return r}return Array.from(t)}(r))).then((0,o.sendResponse)(n,i.default.RESOLVE),(0,o.sendResponse)(n,i.default.REJECT))};var f=u.length;r.push({type:"function",index:f,port:s}),u.push(s)}else r.push({type:"value",value:e});return{args:r,transfer:u}},{args:[],transfer:[]})},e.deserialize=function(t){return t.map(function(t){return"value"===t.type?t.value:function(){for(var e=t.port,r=arguments.length,n=Array(r),i=0;i<r;i++)n[i]=arguments[i];return(0,o.send)(n,{target:e}).then(u.default)}})}},function(t,e){var r=9007199254740991,n=/^(?:0|[1-9]\d*)$/;t.exports=function(t,e){var o=typeof t;return!!(e=null==e?r:e)&&("number"==o||"symbol"!=o&&n.test(t))&&t>-1&&t%1==0&&t<e}},function(t,e,r){var n=r(10),o=function(){try{var t=n(Object,"defineProperty");return t({},"",{}),t}catch(t){}}();t.exports=o},function(t,e,r){var n=r(28);t.exports=function(t,e,r){"__proto__"==e&&n?n(t,e,{configurable:!0,enumerable:!0,value:r,writable:!0}):t[e]=r}},function(t,e,r){var n=r(29),o=r(19),i=Object.prototype.hasOwnProperty;t.exports=function(t,e,r){var u=t[e];i.call(t,e)&&o(u,r)&&(void 0!==r||e in t)||n(t,e,r)}},function(t,e,r){var n=r(30),o=r(20),i=r(27),u=r(8),a=r(18);t.exports=function(t,e,r,c){if(!u(t))return t;for(var s=-1,f=(e=o(e,t)).length,p=f-1,l=t;null!=l&&++s<f;){var v=a(e[s]),d=r;if(s!=p){var y=l[v];void 0===(d=c?c(y,v,l):void 0)&&(d=u(y)?y:i(e[s+1])?[]:{})}n(l,v,d),l=l[v]}return t}},function(t,e,r){var n=r(31);t.exports=function(t,e,r){return null==t?t:n(t,e,r)}},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.invokeApiFunction=e.getDescription=e.buildApiFromDescription=void 0;var n=p(r(0)),o=r(7),i=p(r(5)),u=p(r(32)),a=p(r(9)),c=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(r(26)),s=r(6),f=p(r(16));function p(t){return t&&t.__esModule?t:{default:t}}function l(t){if(Array.isArray(t)){for(var e=0,r=Array(t.length);e<t.length;e++)r[e]=t[e];return r}return Array.from(t)}var v=!0;e.buildApiFromDescription=function(t,e,r){return Object.keys(e).sort().reduce(function(e,i){return(0,u.default)(e,i,function(t,e,r){return function(){for(var i=arguments.length,u=Array(i),a=0;a<i;a++)u[a]=arguments[a];var s=c.serialize(u),p=s.args,l=s.transfer;return(0,o.send)({appId:t,call:r,args:p,intent:n.default.INVOKE_FUNCTION},e,l).then(f.default)}}(t,r,i))},{})};function d(t,e){return(0,a.default)(t)?(r={},n=e.join("."),o=v,n in r?Object.defineProperty(r,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):r[n]=o,r):{};var r,n,o}var y=function t(e,r){var n=function(t,e){return 0===e.length?t:(0,i.default)(t,e)}(r,e),o=Object.keys(n).reduce(function(n,o){return Object.assign(n,t([].concat(l(e),[o]),r))},{});return Object.assign(d(n,e),o)};e.getDescription=function(t){return y([],t)},e.invokeApiFunction=function(t,e){try{var r=c.deserialize(e);return Promise.resolve(t.apply(void 0,l(r))).catch(s.serialize)}catch(t){return(0,s.serialize)(t)}}},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.isEmpty=e.unregisterApp=e.hasApp=e.getAppData=e.getAppById=e.registerApp=void 0;var n,o=r(5),i=(n=o)&&n.__esModule?n:{default:n};var u={};e.registerApp=function(t,e,r){u[t]={app:e,onApiCall:r}},e.getAppById=function(t){return(0,i.default)(u,[t,"app"])},e.getAppData=function(t){return u[t]},e.hasApp=function(t){return Boolean(u[t])},e.unregisterApp=function(t){return delete u[t]},e.isEmpty=function(){return Object.keys(u).length>0}},function(t,e){t.exports=function(t,e){for(var r=-1,n=null==t?0:t.length,o=Array(n);++r<n;)o[r]=e(t[r],r,t);return o}},function(t,e,r){var n=r(13),o=r(35),i=r(15),u=r(14),a=1/0,c=n?n.prototype:void 0,s=c?c.toString:void 0;t.exports=function t(e){if("string"==typeof e)return e;if(i(e))return o(e,t)+"";if(u(e))return s?s.call(e):"";var r=e+"";return"0"==r&&1/e==-a?"-0":r}},function(t,e,r){var n=r(36);t.exports=function(t){return null==t?"":n(t)}},function(t,e,r){var n=r(1);t.exports=function(t,e){var r=n(this,t),o=r.size;return r.set(t,e),this.size+=r.size==o?0:1,this}},function(t,e,r){var n=r(1);t.exports=function(t){return n(this,t).has(t)}},function(t,e,r){var n=r(1);t.exports=function(t){return n(this,t).get(t)}},function(t,e){t.exports=function(t){var e=typeof t;return"string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t}},function(t,e,r){var n=r(1);t.exports=function(t){var e=n(this,t).delete(t);return this.size-=e?1:0,e}},function(t,e,r){var n=r(10)(r(12),"Map");t.exports=n},function(t,e,r){var n=r(2);t.exports=function(t,e){var r=this.__data__,o=n(r,t);return o<0?(++this.size,r.push([t,e])):r[o][1]=e,this}},function(t,e,r){var n=r(2);t.exports=function(t){return n(this.__data__,t)>-1}},function(t,e,r){var n=r(2);t.exports=function(t){var e=this.__data__,r=n(e,t);return r<0?void 0:e[r][1]}},function(t,e,r){var n=r(2),o=Array.prototype.splice;t.exports=function(t){var e=this.__data__,r=n(e,t);return!(r<0||(r==e.length-1?e.pop():o.call(e,r,1),--this.size,0))}},function(t,e){t.exports=function(){this.__data__=[],this.size=0}},function(t,e,r){var n=r(48),o=r(47),i=r(46),u=r(45),a=r(44);function c(t){var e=-1,r=null==t?0:t.length;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}c.prototype.clear=n,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=u,c.prototype.set=a,t.exports=c},function(t,e,r){var n=r(3),o="__lodash_hash_undefined__";t.exports=function(t,e){var r=this.__data__;return this.size+=this.has(t)?0:1,r[t]=n&&void 0===e?o:e,this}},function(t,e,r){var n=r(3),o=Object.prototype.hasOwnProperty;t.exports=function(t){var e=this.__data__;return n?void 0!==e[t]:o.call(e,t)}},function(t,e,r){var n=r(3),o="__lodash_hash_undefined__",i=Object.prototype.hasOwnProperty;t.exports=function(t){var e=this.__data__;if(n){var r=e[t];return r===o?void 0:r}return i.call(e,t)?e[t]:void 0}},function(t,e){t.exports=function(t){var e=this.has(t)&&delete this.__data__[t];return this.size-=e?1:0,e}},function(t,e){t.exports=function(t,e){return null==t?void 0:t[e]}},function(t,e){var r=Function.prototype.toString;t.exports=function(t){if(null!=t){try{return r.call(t)}catch(t){}try{return t+""}catch(t){}}return""}},function(t,e,r){var n=r(12)["__core-js_shared__"];t.exports=n},function(t,e,r){var n,o=r(56),i=(n=/[^.]+$/.exec(o&&o.keys&&o.keys.IE_PROTO||""))?"Symbol(src)_1."+n:"";t.exports=function(t){return!!i&&i in t}},function(t,e,r){var n=r(9),o=r(57),i=r(8),u=r(55),a=/^\[object .+?Constructor\]$/,c=Function.prototype,s=Object.prototype,f=c.toString,p=s.hasOwnProperty,l=RegExp("^"+f.call(p).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");t.exports=function(t){return!(!i(t)||o(t))&&(n(t)?l:a).test(u(t))}},function(t,e,r){var n=r(3);t.exports=function(){this.__data__=n?n(null):{},this.size=0}},function(t,e,r){var n=r(59),o=r(53),i=r(52),u=r(51),a=r(50);function c(t){var e=-1,r=null==t?0:t.length;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}c.prototype.clear=n,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=u,c.prototype.set=a,t.exports=c},function(t,e,r){var n=r(60),o=r(49),i=r(43);t.exports=function(){this.size=0,this.__data__={hash:new n,map:new(i||o),string:new n}}},function(t,e,r){var n=r(61),o=r(42),i=r(40),u=r(39),a=r(38);function c(t){var e=-1,r=null==t?0:t.length;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}c.prototype.clear=n,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=u,c.prototype.set=a,t.exports=c},function(t,e,r){var n=r(62),o="Expected a function";function i(t,e){if("function"!=typeof t||null!=e&&"function"!=typeof e)throw new TypeError(o);var r=function(){var n=arguments,o=e?e.apply(this,n):n[0],i=r.cache;if(i.has(o))return i.get(o);var u=t.apply(this,n);return r.cache=i.set(o,u)||i,u};return r.cache=new(i.Cache||n),r}i.Cache=n,t.exports=i},function(t,e,r){var n=r(63),o=500;t.exports=function(t){var e=n(t,function(t){return r.size===o&&r.clear(),t}),r=e.cache;return e}},function(t,e,r){var n=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,o=/\\(\\)?/g,i=r(64)(function(t){var e=[];return 46===t.charCodeAt(0)&&e.push(""),t.replace(n,function(t,r,n,i){e.push(n?i.replace(o,"$1"):r||t)}),e});t.exports=i},function(t,e){var r=Object.prototype.toString;t.exports=function(t){return r.call(t)}},function(t,e,r){var n=r(13),o=Object.prototype,i=o.hasOwnProperty,u=o.toString,a=n?n.toStringTag:void 0;t.exports=function(t){var e=i.call(t,a),r=t[a];try{t[a]=void 0;var n=!0}catch(t){}var o=u.call(t);return n&&(e?t[a]=r:delete t[a]),o}},function(t,e){var r;r=function(){return this}();try{r=r||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(r=window)}t.exports=r},function(t,e,r){(function(e){var r="object"==typeof e&&e&&e.Object===Object&&e;t.exports=r}).call(this,r(68))},function(t,e,r){var n=r(15),o=r(14),i=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,u=/^\w*$/;t.exports=function(t,e){if(n(t))return!1;var r=typeof t;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=t&&!o(t))||u.test(t)||!i.test(t)||null!=e&&t in Object(e)}},function(t,e,r){var n=r(20),o=r(18);t.exports=function(t,e){for(var r=0,i=(e=n(e,t)).length;null!=t&&r<i;)t=t[o(e[r++])];return r&&r==i?t:void 0}},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.unset=e.request=e.set=void 0;var n=l(r(5)),o=p(r(34)),i=r(17),u=l(r(0)),a=r(33),c=r(7),s=p(r(21)),f=r(6);function p(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}function l(t){return t&&t.__esModule?t:{default:t}}var v=function(t){var e=t.data,r=e.appId,i=e.intent,s=e.call,p=e.args,l=e.__port;switch(i){case u.default.REQUEST_API:var v=o.getAppById(r),d=v?(0,a.getDescription)(v):null;return l.postMessage(d),Promise.resolve();case u.default.INVOKE_FUNCTION:var y=o.getAppData(r);if(!y){var h=new Error("The API for "+r+" has been removed");return(0,c.sendResponse)(l,u.default.REJECT)((0,f.serialize)(h))}y.onApiCall&&y.onApiCall({appId:r,call:s,args:p});var _=(0,n.default)(y.app,s);return(0,a.invokeApiFunction)(_,p).then((0,c.sendResponse)(l,u.default.RESOLVE),(0,c.sendResponse)(l,u.default.REJECT))}return Promise.resolve()};e.set=function(t,e){var r=(arguments.length>2&&void 0!==arguments[2]?arguments[2]:{}).onApiCall;o.hasApp(t)&&o.unregisterApp(t),o.registerApp(t,e,r),s.addSingleHandler(v)},e.request=function(t){var e=function(t){var e=t.target,r=t.initiator;switch(!0){case(0,i.isWorker)():return{target:self,targetOrigin:"*"};case"undefined"!=typeof parent&&e===parent:return{target:parent,targetOrigin:"*"};case e instanceof Worker:return{target:e};case Boolean(e):return e.contentWindow?{target:e.contentWindow,targetOrigin:e.src}:{target:e,targetOrigin:"*"};case Boolean(r):var n=(0,i.getChildFrameById)(r);return{target:n.contentWindow,targetOrigin:n.src};default:throw new Error("Invalid target")}}(arguments.length>1&&void 0!==arguments[1]?arguments[1]:{});return(0,c.send)({intent:u.default.REQUEST_API,appId:t},e).then(function(r){return r?(0,a.buildApiFromDescription)(t,r,e):Promise.reject(new Error("App with ID "+t+" not found"))})},e.unset=function(t){o.unregisterApp(t),o.isEmpty()&&s.removeSingleHandler(v)}},function(t,e,r){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.api=void 0;var n=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(r(72));e.api=n}])});
//# sourceMappingURL=pm-rpc.min.js.map

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(11);
var createDesc = __webpack_require__(33);
module.exports = __webpack_require__(13) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(34);
__webpack_require__(39);
module.exports = __webpack_require__(73).f('iterator');


/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(200);
__webpack_require__(75);
__webpack_require__(203);
__webpack_require__(204);
module.exports = __webpack_require__(2).Symbol;


/***/ }),

/***/ 17:
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(35);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(5);
var has = __webpack_require__(17);
var DESCRIPTORS = __webpack_require__(13);
var $export = __webpack_require__(7);
var redefine = __webpack_require__(85);
var META = __webpack_require__(91).KEY;
var $fails = __webpack_require__(18);
var shared = __webpack_require__(48);
var setToStringTag = __webpack_require__(37);
var uid = __webpack_require__(36);
var wks = __webpack_require__(6);
var wksExt = __webpack_require__(73);
var wksDefine = __webpack_require__(74);
var enumKeys = __webpack_require__(201);
var isArray = __webpack_require__(123);
var anObject = __webpack_require__(12);
var isObject = __webpack_require__(14);
var toIObject = __webpack_require__(23);
var toPrimitive = __webpack_require__(56);
var createDesc = __webpack_require__(33);
var _create = __webpack_require__(53);
var gOPNExt = __webpack_require__(202);
var $GOPD = __webpack_require__(118);
var $DP = __webpack_require__(11);
var $keys = __webpack_require__(29);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(113).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(40).f = $propertyIsEnumerable;
  __webpack_require__(57).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(28)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(16)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(29);
var gOPS = __webpack_require__(57);
var pIE = __webpack_require__(40);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(23);
var gOPN = __webpack_require__(113).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('asyncIterator');


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74)('observable');


/***/ }),

/***/ 22:
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(52);
var defined = __webpack_require__(42);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ 25:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(42);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ 28:
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(71);
var enumBugKeys = __webpack_require__(49);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(93), __esModule: true };

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(127)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(61)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ 35:
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ 36:
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(11).f;
var has = __webpack_require__(17);
var TAG = __webpack_require__(6)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(130);
var global = __webpack_require__(5);
var hide = __webpack_require__(16);
var Iterators = __webpack_require__(22);
var TO_STRING_TAG = __webpack_require__(6)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ 40:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.proGalleryItemsToWixCode = exports.proGalleryItemToWixCode = exports.wixCodeItemsToProGallery = exports.wixCodeItemToProGallery = undefined;

var _extends2 = __webpack_require__(407);

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__(312);

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = __webpack_require__(408);

var _typeof3 = _interopRequireDefault(_typeof2);

var _utils = __webpack_require__(411);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatTextLinkToObject = function formatTextLinkToObject(link, target) {
  switch (typeof link === 'undefined' ? 'undefined' : (0, _typeof3.default)(link)) {
    case 'object':
      return {
        type: 'wix',
        data: link
      };
    case 'string':
      return {
        type: 'web',
        url: link,
        target: target
      };
    default:
      return {
        target: '_blank',
        type: 'none'
      };
  }
};

var formatObjectLinkToText = function formatObjectLinkToText() {
  var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  //todo - update defs from here: https://www.wix.com/code/reference/$w.LinkableMixin.html#link
  var _link = {
    link: link.url
  };
  if (link.url) {
    _link.target = link.target;
  }
  return _link;
};

var isWixSrc = function isWixSrc(src) {
  var regex = /^wix:(image|video):/;
  return regex.exec(src) !== null;
};

var formatSrcToMediaUrl = function formatSrcToMediaUrl(src) {
  return isWixSrc(src) ? src.split('/')[3] : src; //convert from wix:image://v1/[mediaUrl]/
};

var formatSrcToFilename = function formatSrcToFilename(src) {
  try {
    return isWixSrc(src) ? src.split('/')[4].split('#')[0] : '_.jpg'; //convert from wix:image://v1/[mediaUrl]/
  } catch (e) {
    return '_.jpg';
  }
};

var formatImageUrlToSrc = function formatImageUrlToSrc(mediaUrl, meta) {
  return 'wix:image://v1/' + (mediaUrl || utils.slugify(meta.name)) + '/' + utils.slugify(meta.fileName) + '#originWidth=' + meta.width + '&originHeight=' + meta.height;
};

var formatVideoUrlToSrc = function formatVideoUrlToSrc(videoUrl, posterUrl, meta) {
  return 'wix:video://v1/' + (videoUrl || utils.slugify(meta.name)) + '/' + utils.slugify(meta.fileName) + '#posterUri=' + posterUrl + '&posterWidth=' + meta.width + '&posterHeight=' + meta.height;
};

var dimensionsFromUrl = function dimensionsFromUrl(url) {
  /*
  Breaks a url of this format : wix:image://v1/<uri>/<filename>#originWidth=<width>&originHeight=<height>[&watermark=<watermark_manifest_string>]
  to a hash like this  {
    originalWidth: <width>
    originalHeight: <height>
    watermark: <watermark_manifest_string>
  }
  */
  var dimensions = {};
  try {
    url.split('#')[1].split('&').map(function (dim) {
      return dim.split('=');
    }).forEach(function (dim) {
      dimensions[dim[0]] = isNaN(Number(dim[1])) ? String(dim[1]) : Number(dim[1]);
    });
  } catch (e) {
    //
  }
  return dimensions;
};

var oldWixCodeItemToProGallery = function oldWixCodeItemToProGallery(wixCodeItem, i) {
  return {
    itemId: utils.createUniqueUuidFromString(i + '_' + (wixCodeItem.uri || wixCodeItem.alt || i)),
    mediaUrl: wixCodeItem.uri || 'no_image.jpg',
    metaData: {
      height: wixCodeItem.height || 1,
      lastModified: Date.now(),
      link: formatTextLinkToObject(wixCodeItem.link, wixCodeItem.target),
      title: wixCodeItem.title || '',
      description: wixCodeItem.description || '',
      alt: wixCodeItem.alt || '',
      sourceName: 'private',
      tags: [],
      width: wixCodeItem.width || 1
    },
    orderIndex: i
  };
};

var newWixCodeItemToProGallery = function newWixCodeItemToProGallery(wixCodeItem, i) {
  var dimensions = dimensionsFromUrl(wixCodeItem.src);
  dimensions.width = wixCodeItem.width || dimensions.originWidth || dimensions.originalWidth || dimensions.posterWidth || 1;
  dimensions.height = wixCodeItem.height || dimensions.originHeight || dimensions.originalHeight || dimensions.posterHeight || 1;
  var focalPoint = wixCodeItem.settings && wixCodeItem.settings.focalPoint;
  var item = {
    itemId: utils.slugify(wixCodeItem.slug) || utils.slugify(wixCodeItem.title) || utils.createUniqueUuidFromString(wixCodeItem.src || wixCodeItem.html || i),
    mediaUrl: formatSrcToMediaUrl(wixCodeItem.src),
    metaData: (0, _assign2.default)({
      type: wixCodeItem.type || 'image',
      alt: wixCodeItem.title || '',
      title: wixCodeItem.title || '',
      description: wixCodeItem.description || '',
      name: formatSrcToFilename(wixCodeItem.src),
      fileName: formatSrcToFilename(wixCodeItem.src),
      link: formatTextLinkToObject(wixCodeItem.link, wixCodeItem.target),
      width: dimensions.width,
      height: dimensions.height,
      sourceName: 'private'
    }, focalPoint ? { focalPoint: focalPoint } : {}),
    orderIndex: i
  };

  if (wixCodeItem.type === 'text') {
    var style = wixCodeItem.style;
    item.metaData.height = dimensions.height || 500;
    item.metaData.width = dimensions.width || 500 * style.layoutRatio;
    item.metaData.textStyle = {
      width: item.metaData.width,
      height: item.metaData.height,
      backgroundColor: style.fillColor
    };
    item.metaData.html = item.editorHtml = wixCodeItem.html;
  }

  if (wixCodeItem.type === 'video') {
    item.metaData.posters = [{
      url: dimensions.posterUri || wixCodeItem.thumbnail,
      width: dimensions.width,
      height: dimensions.height
    }];
    item.isExternal = wixCodeItem.src.indexOf('http') === 0;
    if (item.isExternal || isWixSrc(wixCodeItem.src)) {
      item.metaData.source = wixCodeItem.src.indexOf('youtube.com') > 0 ? 'youtube' : wixCodeItem.src.indexOf('vimeo.com') > 0 ? 'vimeo' : 'wix';
      item.metaData.videoUrl = wixCodeItem.src;
    } else {
      item.metaData.qualities = [{
        width: dimensions.width,
        height: dimensions.height,
        quality: dimensions.height + 'p',
        formats: [isWixSrc(wixCodeItem.src) ? 'wix' : wixCodeItem.src.split(/#|\?/)[0].split('.').pop().trim()]
      }];
    }
  }

  return item;
};

var isNewWixCodeItemFormat = function isNewWixCodeItemFormat(wixCodeItem) {
  return !!(wixCodeItem.type && (wixCodeItem.src || wixCodeItem.html));
};

var wixCodeItemToProGallery = function wixCodeItemToProGallery(wixCodeItem) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  return isNewWixCodeItemFormat(wixCodeItem) ? newWixCodeItemToProGallery(wixCodeItem, i) : oldWixCodeItemToProGallery(wixCodeItem, i);
};

var wixCodeItemsToProGallery = function wixCodeItemsToProGallery(wixCodeItems) {

  var formattedItemsDto = [];
  try {
    wixCodeItems.forEach(function (wixCodeItem, i) {
      return formattedItemsDto.push(wixCodeItemToProGallery(wixCodeItem, i));
    });
    // console.log('Converted wix code items', wixCodeItems, formattedItemsDto);
  } catch (e) {
    console.error('Wrong format for gallery items', wixCodeItems, e);
  }
  return formattedItemsDto;
};

var proGalleryItemToOldWixCode = function proGalleryItemToOldWixCode(itemDto) {
  var meta = itemDto.metaData || itemDto.metadata || {};
  var link = formatObjectLinkToText(meta.link) || {};
  return (0, _extends3.default)({
    uri: itemDto.mediaUrl,
    description: meta.description,
    alt: meta.title,
    title: meta.title,
    height: meta.height,
    width: meta.width
  }, link);
};

//gallery-type editor: convert from orginaize-media to wix-code
var proGalleryItemToNewWixCode = function proGalleryItemToNewWixCode() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


  var meta = item.metaData || item.metadata || {};
  var link = formatObjectLinkToText(meta.link) || {};
  var dbItem = (0, _extends3.default)({
    type: meta.type || 'image',
    slug: item.itemId
  }, link);
  var type = dbItem.type;
  if (type === 'text') {
    var style = meta.testStyle || {};
    (0, _assign2.default)(dbItem, {
      html: meta.html,
      style: {
        width: style.width,
        height: style.height,
        bgColor: style.backgroundColor
      }
    });
  } else {
    (0, _assign2.default)(dbItem, {
      title: meta.title,
      description: meta.description
    });
    if (type === 'image') {
      (0, _assign2.default)(dbItem, {
        src: formatImageUrlToSrc(item.mediaUrl, meta),
        settings: (0, _assign2.default)({}, meta.focalPoint ? {
          focalPoint: meta.focalPoint
        } : {})
      });
    } else if (type === 'video') {
      (0, _assign2.default)(dbItem, {
        src: formatVideoUrlToSrc(item.mediaUrl, meta),
        thumbnail: item.mediaUrl
      });
    }
  }
  return dbItem;
};

var proGalleryItemToWixCode = function proGalleryItemToWixCode() {
  var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isNew = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return isNew ? proGalleryItemToNewWixCode(item) : proGalleryItemToOldWixCode(item);
};

var proGalleryItemsToWixCode = function proGalleryItemsToWixCode(itemsDto) {
  var isNew = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var formattedItemsDto = [];
  itemsDto.forEach(function (itemDto) {
    return formattedItemsDto.push(proGalleryItemToWixCode(itemDto, isNew));
  });
  return formattedItemsDto;
};

exports.wixCodeItemToProGallery = wixCodeItemToProGallery;
exports.wixCodeItemsToProGallery = wixCodeItemsToProGallery;
exports.proGalleryItemToWixCode = proGalleryItemToWixCode;
exports.proGalleryItemsToWixCode = proGalleryItemsToWixCode;

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(312);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(409);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(410);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(165), __esModule: true };

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(166), __esModule: true };

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slugify = exports.createUniqueUuidFromString = undefined;

var _sign = __webpack_require__(412);

var _sign2 = _interopRequireDefault(_sign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
var uniqueUuids = {};
var createUniqueUuidFromString = function createUniqueUuidFromString(str, retry) {
  function hashToInt(str) {
    var hash = 0;

    if (typeof str === 'undefined' || str.length === 0) {
      return hash;
    }
    for (var i = 0; i < str.length; i++) {
      var chr = str.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
    hash *= (0, _sign2.default)(hash);
    hash = Math.sqrt(hash);
    hash = Math.floor((hash - Math.floor(hash)) * 1000000);

    return hash;
  }

  var num = hashToInt(str);

  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c, i) {
    var r = Math.ceil(num / (i + 1)) % 16,
        v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
  // console.log('Generated uuid & number from string', num, uuid, str);

  if (uniqueUuids[uuid]) {
    //unique uuid already exists!
    console.warn('Pro Gallery - unique uuid already exists', num, retry, { old: uniqueUuids[uuid], new: num });
    if (typeof retry === 'undefined' || retry > 0) {
      return createUniqueUuidFromString(str + 'x', (retry || 10) - 1);
    } else {
      console.error('Pro Gallery - cannot create unique uuid', str, num);
      return uuid;
    }
  } else {
    uniqueUuids[uuid] = num;
    return uuid;
  }
};

var slugify = function slugify() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return text.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
  .replace(/[^\w\-]+/g, '') // Remove all non-word chars
  .replace(/\-\-+/g, '-') // Replace multiple - with single -
  .replace(/^-+/, '') // Trim - from start of text
  .replace(/-+$/, ''); // Trim - from end of text
};

exports.createUniqueUuidFromString = createUniqueUuidFromString;
exports.slugify = slugify;

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(413), __esModule: true };

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(414);
module.exports = __webpack_require__(2).Math.sign;


/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(7);

$export($export.S, 'Math', { sign: __webpack_require__(415) });


/***/ }),

/***/ 415:
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),

/***/ 42:
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(48)('keys');
var uid = __webpack_require__(36);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(41);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var document = __webpack_require__(5).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(2);
var global = __webpack_require__(5);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(28) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ 49:
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(25);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(12);
var dPs = __webpack_require__(129);
var enumBugKeys = __webpack_require__(49);
var IE_PROTO = __webpack_require__(44)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(47)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(83).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(14);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 57:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(48)('wks');
var uid = __webpack_require__(36);
var Symbol = __webpack_require__(5).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(28);
var $export = __webpack_require__(7);
var redefine = __webpack_require__(85);
var hide = __webpack_require__(16);
var Iterators = __webpack_require__(22);
var $iterCreate = __webpack_require__(128);
var setToStringTag = __webpack_require__(37);
var getPrototypeOf = __webpack_require__(87);
var ITERATOR = __webpack_require__(6)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(2);
var ctx = __webpack_require__(20);
var hide = __webpack_require__(16);
var has = __webpack_require__(17);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(13) && !__webpack_require__(18)(function () {
  return Object.defineProperty(__webpack_require__(47)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(17);
var toIObject = __webpack_require__(23);
var arrayIndexOf = __webpack_require__(107)(false);
var IE_PROTO = __webpack_require__(44)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(6);


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(2);
var LIBRARY = __webpack_require__(28);
var wksExt = __webpack_require__(73);
var defineProperty = __webpack_require__(11).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ 75:
/***/ (function(module, exports) {



/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(5).document;
module.exports = document && document.documentElement;


/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(16);


/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(17);
var toObject = __webpack_require__(27);
var IE_PROTO = __webpack_require__(44)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(36)('meta');
var isObject = __webpack_require__(14);
var has = __webpack_require__(17);
var setDesc = __webpack_require__(11).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(18)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(109);
module.exports = __webpack_require__(2).Object.assign;


/***/ }),

/***/ 94:
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ })

/******/ });


// WEBPACK FOOTER //
// wixCodeApi.bundle.min.js